export const language: any = {
  LabelFavorites: "รายการโปรด",
  LabelYouDontHaveRecipeAddYourFavoriteRecipe: `ยังไม่มีสูตรอาหารในรายการโปรดของคุณ<br/>ลองเพิ่มสูตรที่คุณชอบดูสิ!`,
  LabelDoYouWantUnSave: `คุณต้องการยกเลิกการบันทึกสูตรนี้หรือไม่?`,
  save: "บันทึก",
  unsave: "ยกเลิกการบันทึก",
  OkFavorite: "ใช่",
  CloseFavorite: "ไม่ใช่",
};
